import React from 'react';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  const comparisons = [
    { feature: 'Acesso Ilimitado', traditional: false, elion: true },
    { feature: '100% da Comissão', traditional: false, elion: true },
    { feature: 'Autonomia Total', traditional: false, elion: true },
    { feature: 'Sua Marca em Evidência', traditional: false, elion: true },
    { feature: 'Tecnologia Avançada', traditional: false, elion: true },
    { feature: 'Rede de Relacionamentos', traditional: false, elion: true },
    { feature: 'Alcance Nacional', traditional: false, elion: true },
  ];

  return (
    <section className="py-20 bg-[#0e1a2b]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            O Futuro da Intermediação Imobiliária Está Aqui
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Descubra como criar sua Sociedade Imobiliária e transformar
            liberdade e autonomia em faturamento.
          </p>
        </div>

        <div className="max-w-4xl mx-auto relative">
          {/* Card principal */}
          <div className="relative bg-[#16263e] border border-yellow-500/30 rounded-lg p-8 shadow-lg">
            <div className="grid grid-cols-3 gap-4 mb-6">
              <div></div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-200">
                  Modelo Tradicional
                </h3>
              </div>
              <div className="text-center">
                <h3 className="text-xl font-bold text-yellow-400">
                  Sociedade Elion
                </h3>
              </div>
            </div>

            {comparisons.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-3 gap-4 py-4 border-b border-gray-700 last:border-b-0"
              >
                <div className="font-semibold text-white">{item.feature}</div>
                <div className="text-center">
                  {item.traditional ? (
                    <Check className="w-6 h-6 text-green-400 mx-auto" />
                  ) : (
                    <X className="w-6 h-6 text-red-500 mx-auto" />
                  )}
                </div>
                <div className="text-center">
                  {item.elion ? (
                    <Check className="w-6 h-6 text-yellow-400 mx-auto" />
                  ) : (
                    <X className="w-6 h-6 text-red-500 mx-auto" />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
